import React from 'react';
import PropTypes from 'prop-types';
import PrintSizeType from '../types/print-size-type';
import PrintsAllDeleted from './prints-all-deleted';
import PrintsSizeDeleted from './prints-size-deleted';
import Summary from './summary';
import SpinnerCover from '../../_utils/spinner-cover';
import deliveryOptionsCalculator from '../../_utils/_delivery-options/calculator';
import OrderContents from '../../_utils/_order-data/order-contents';
import DeliveryOptions from '../delivery-options';
import PrintStack from './print-stack';
import OutOfStockWarning from '../out-of-stock-warning';
import CartItemsChangeEvents from '../cart-items-change-events';
import { builderDispatch } from '../../_utils/ui';

const Prints = (props, { unavailableItems, selectedLocation }) => {
  const {
    sizes,
    deletedFinishes,
    delivery,
    delivery_options,
    updating,
    thumbnail,
    alternatePickupStore,
  } = props;

  const aliveSizes = sizes.filter(
    size => !size.deleted && !deletedFinishes.includes(size.print_finish_key)
  );
  const quantity = aliveSizes.reduce((memo, size) => memo + size.quantity, 0);
  const lastDeletedSize = sizes
    .filter(
      size => size.deleted && !deletedFinishes.includes(size.print_finish_key)
    )
    .sort((a, b) => b.deleted - a.deleted)[0];

  const chosenDeliveryOption = OrderContents.selectedDeliveryOption({
    delivery,
    delivery_options,
  });

  const printsUnavailable = (() => {
    if (deliveryOptionsCalculator.isShipping(chosenDeliveryOption)) {
      return;
    }
    return unavailableItems.find(
      item => item.prints && item.storeId === selectedLocation
    );
  })();

  const setStoreToAlternate = () => {
    const { id: storeId } = alternatePickupStore || {};

    if(!storeId) { return; }

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.PICKUP_LOCATION_CHANGE,
      value: storeId,
    });
  };

  return (
    <SpinnerCover spinning={updating}>
      <section className="prints">
        {!!deletedFinishes.length &&
          deletedFinishes.map(deletedFinish => (
            <PrintsAllDeleted
              key={deletedFinish}
              deletedFinish={deletedFinish}
              sizes={sizes}
            />
          ))}
        {lastDeletedSize && <PrintsSizeDeleted {...lastDeletedSize} />}
        {!!aliveSizes.length && (
          <div className="row">
            <div className="col-12">
              {printsUnavailable && (
                <OutOfStockWarning
                  alternateStore={alternatePickupStore}
                  setStoreToAlternate={setStoreToAlternate}
                  productMessage={printsUnavailable.message.full} />
              )}
            </div>
            <div className="col-md-2">
              <div className="row">
                <div className="offset-3 col-6 offset-sm-4 col-sm-4 offset-md-0 col-md-12">
                  <PrintStack thumbnail={thumbnail} />
                </div>
              </div>
            </div>
            <div className="col-md-10">
              <Summary sizes={aliveSizes} quantity={quantity} />
              <DeliveryOptions
                options={delivery_options}
                selectedOption={delivery}
              />
            </div>
          </div>
        )}
      </section>
    </SpinnerCover>
  );
};

Prints.contextTypes = {
  selectedLocation: PropTypes.string,
  unavailableItems: PropTypes.array,
};

Prints.propTypes = {
  sizes: PropTypes.arrayOf(PrintSizeType),
  deletedFinishes: PropTypes.arrayOf(PropTypes.string),
  delivery: PropTypes.number,
  delivery_options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number,
      title: PropTypes.string,
      type: PropTypes.string,
      time_hours: PropTypes.number,
      partner_id: PropTypes.string,
      sort_order: PropTypes.number,
    })
  ),
  updating: PropTypes.bool,
  thumbnail: PropTypes.string,
  alternatePickupStore: PropTypes.object
};

export default Prints;
